import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientTransactionUpdateModal2UI from './ClientTransactionUpdateModal2UI.js'

class ClientTransactionUpdateModal2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      category: (this.props.category == 'trade_debits' || this.props.category == 'trade_credits') ? '' : this.props.category,
      categoryError: null,
      categoryList: [],
      categoryMappedValueCreditList: [],
      categoryMappedValueDebitList: [],
      isCredit: true
    }
  }

  render() {
    return (
      <ClientTransactionUpdateModal2UI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        category={this.state.category}
        onCategoryChange={(event) => { this.setState({ category: event.target.value }) }}
        categoryError={this.state.categoryError}
        setCategoryError={(error) => { this.setState({ categoryError: error }) }}
        categoryMappedValueCreditList={this.state.categoryMappedValueCreditList}
        categoryMappedValueDebitList={this.state.categoryMappedValueDebitList}
        isCredit={this.state.isCredit}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
    this.getBankAnalyzerCategories(context)
  }

  componentDidUpdate(prevProps) {
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/clientTransactions/categories`,
      this.onSubmitCallback, {
        category: this.state.category,
        transactionIdList: this.props.selectedTxnIdList
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.ClientTxnCats(this.props.account.accountId))
      this.props.onRefreshClick(`New total for category ${this.state.category}: ${response.totalF2}`)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  //setErrorList = (errorList) => {
  //  this.setState({errorList: errorList})
  //}

  getBankAnalyzerCategories(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAnalyzerCategories`,
      cacheKey: CacheKeys.BankAnalyzerCategories(),
      callback: this.getBankAnalyzerCategoriesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getBankAnalyzerCategoriesCallback = (response) => {
    console.log(this.state.category);
    console.log(response.codeLabelList)
    let mappedValueCreditList = response.codeLabelList.filter(cat => cat.credit).map(cat => ({key: cat.code, value: cat.label}))
    let mappedValueDebitList = response.codeLabelList.filter(cat => !cat.credit).map(cat => ({key: cat.code, value: cat.label}))

    let isCredit
    if (this.props.category === 'trade_credits')
      isCredit = true
    else if (this.props.category === 'trade_debits')
      isCredit = false
    else
      isCredit = response.codeLabelList.filter(c => c.code === this.props.category)[0].credit

    this.setState({
      categoryMappedValueCreditList: mappedValueCreditList,
      categoryMappedValueDebitList: mappedValueDebitList,
      categoryList: response.codeLabelList,
      isCredit: isCredit
    })
  }
}

export default withRouter(ClientTransactionUpdateModal2SF)
